import React from "react";
import { Button, Tag } from "antd";
import { ArrowLeftOutlined, CheckCircleFilled } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function DashboardBreadcrumb(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const [cycleFinalized, setCycleFinalized] = React.useState(false);
  
  // Check if we're on an objectives/plans page
  const isObjectivesPage = location.pathname.includes('/positions-performance/') || 
                          location.pathname.includes('/units/');

  const handleCycleFinalizedToggle = () => {
    setCycleFinalized(!cycleFinalized);
    // This is purely cosmetic for now - no API call needed
  };
  
  return (
    <div
      className="shadow-sm border-b"
      style={{ padding: "12px 24px", backgroundColor: "#fff" }}
    >
      {/* Performance Cycle Header - only show on objectives pages */}
      {isObjectivesPage && perfCycleState && (
        <div className="flex items-center justify-between mb-2 pb-2 border-b border-gray-100">
          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-600">Performance Cycle:</span>
            <span 
              className="font-medium text-gray-900 cursor-pointer hover:text-blue-600"
              onClick={handleCycleFinalizedToggle}
              title="Click to toggle finalized status (cosmetic)"
            >
              {perfCycleState.name}
            </span>
            {/* Cosmetic finalized toggle for performance cycles (gold checkmark) */}
            <CheckCircleFilled 
              style={{ 
                color: cycleFinalized ? '#FFD700' : '#D1D5DB', 
                fontSize: '16px',
                cursor: 'pointer',
                transition: 'color 0.2s ease'
              }} 
              onClick={handleCycleFinalizedToggle}
              title={cycleFinalized ? "Performance Cycle Finalized (Cosmetic)" : "Click to mark as finalized (Cosmetic)"}
            />
            {cycleFinalized && (
              <span className="text-xs text-green-600 font-medium">Finalized</span>
            )}
          </div>
          <Tag color="blue" className="text-xs">
            {perfCycleState.status || 'Active'}
          </Tag>
        </div>
      )}
      
      <div className="flex justify-between items-center h-8">
        <div className="flex items-center">{props.left}</div>
        <div className="flex items-center">{props.right}</div>
      </div>
    </div>
  );
}

export default DashboardBreadcrumb;
